export const seoData = {
  "/": {
    title: "Revenue Cycle Management Services | RCM Healthcare Services",
    description:
      "Streamline healthcare revenue with end-to-end Revenue Cycle Management services from billing and coding to claims and collections, maximizing revenue & reducing denials.",
    keywords:
      "rcm healthcare services, medical billing services, revenue cycle management",
  },

  "/about": {
    title:
      "Healthcare Revenue Cycle Management | Outsource Medical Billing",
    description:
      "Partner with experts in healthcare revenue cycle management and outsource medical billing services to boost cash flow, reduce denials & achieve faster payments.",
    keywords:
      "healthcare revenue cycle management, outsource medical billing, outsource medical billing services",
  },

  "/contact": {
    title: "Contact Us | PROBill RCM Services",
    description:
      "Get in touch with PROBill RCM experts for reliable healthcare billing, coding, and revenue cycle management solutions tailored to your needs.",
    keywords: "contact medical billing company, rcm services contact",
  },

  "/privacy-policy": {
    title: "Privacy Policy | PROBill RCM",
    description:
      "Read the privacy policy of PROBill RCM to understand how we collect, use, and protect your information securely.",
    keywords: "privacy policy, data protection, probill rcm",
  },

  "/terms-conditions": {
    title: "Terms and Conditions | PROBill RCM",
    description:
      "Review the terms and conditions of PROBill RCM services including usage policies, responsibilities, and compliance details.",
    keywords: "terms and conditions, probill rcm terms",
  },

  // SERVICES
  "/services/nurse-practitioners": {
    title:
      "Nurse Practitioner Billing Services | Medical Billing for NPs",
    description:
      "Reliable medical billing for nurse practitioners with expert NP billing services. Reduce errors, speed reimbursements, and improve cash flow.",
    keywords:
      "nurse practitioner billing, medical billing for nurse practitioners, np billing services",
  },

  "/services/mental-health": {
    title:
      "Mental Health Billing Services | Behavioral Billing Experts",
    description:
      "Simplify behavioral & mental health billing services with accurate claims, fewer denials, and faster payments.",
    keywords:
      "mental health billing services, behavioral billing, mental health billing company",
  },

  "/services/chiro": {
    title:
      "Chiropractic Billing Services | Chiropractic Medical Billing",
    description:
      "Spend more time with patients while our chiropractic billing services manage claims, compliance, and payments efficiently.",
    keywords:
      "chiropractic billing services, chiropractic medical billing services",
  },

  "/services/family-medicine": {
    title:
      "Family Practice Medical Billing | Family Medicine Billing Services",
    description:
      "Improve cash flow with expert family practice medical billing services designed to reduce errors and ensure consistent payments.",
    keywords:
      "family practice medical billing, family medicine billing services",
  },

  "/services/internal-medicine": {
    title: "Expert Internal Medicine Billing Services | PROBill",
    description:
      "Smarter internal medicine billing services ensuring accurate coding, reduced denials, and steady reimbursements.",
    keywords:
      "internal medicine billing services, internal medicine medical billing",
  },

  "/services/pt": {
    title:
      "Physical Therapy Billing Services | PT Medical Billing | PROBill",
    description:
      "Focus on patient recovery while we manage your physical therapy billing, claims, and compliance efficiently.",
    keywords:
      "physical therapy billing services, pt billing, physical therapy medical billing",
  },

  // INDUSTRIES
  "/industries/accounts-receivable": {
    title:
      "Accounts Receivable Services | Receivable Management Services",
    description:
      "Accelerate collections and reduce denials with expert medical accounts receivable services.",
    keywords: "accounts receivable services, receivable management services",
  },

  "/industries/denial-management": {
    title:
      "Best Denial Management Services for Healthcare Providers | PROBill",
    description:
      "Turn denials into revenue with advanced denial management services that reduce rejections and improve reimbursements.",
    keywords:
      "denial management services, denial management in healthcare",
  },

  "/industries/charge-entry-audit": {
    title:
      "Charge Entry & Audit Services for Healthcare | PROBill",
    description:
      "Enhance billing accuracy and reduce errors with professional charge entry and audit services.",
    keywords:
      "charge entry services, charge entry audit, medical billing charge entry",
  },

  "/industries/account-reconciliation": {
    title:
      "Account Reconciliation Services | Healthcare Billing Services",
    description:
      "Eliminate revenue gaps with accurate account reconciliation services and maintain financial records efficiently.",
    keywords:
      "account reconciliation services, healthcare billing services",
  },

  "/industries/payment-posting": {
    title:
      "Payment Posting Services | Accurate Medical Billing | PROBill",
    description:
      "Boost revenue with accurate payment posting services ensuring quick reconciliation and improved cash flow.",
    keywords:
      "payment posting services, medical billing outsourcing",
  },

  "/industries/credentialing": {
    title:
      "Certified Provider Credentialing Specialist | PROBill",
    description:
      "Streamline provider enrollment with certified credentialing specialists ensuring compliance and faster approvals.",
    keywords:
      "provider credentialing services, provider enrollment",
  },

  // BLOG
  "/blog": {
    title: "Healthcare Billing Blog | PROBill RCM Insights",
    description:
      "Explore insights, tips, and updates on medical billing, coding, and revenue cycle management.",
    keywords:
      "medical billing blog, rcm insights, healthcare billing articles",
  },
};
